export const SUCCESS_MESSAGES = {
  PLACE_BIDS_SUCCESSFUL: 'New bids successful',
  BIDS_CANCELED_SUCCESSFULLY: 'Bid cancelled successfully'
};

export const FAILURE_MESSAGES = {
  CATALOG_DATA_NOT_FOUND: 'Catalog data not found.',
  SALE_INFO_NOT_FOUND: 'Sale info not found.',
  BID_HISTORY_AND_CANCEL_COUNT_FETCH_ERRROR: 'Unable to fetch bid history and cancel count.',
  SHOW_SELECTED_LOT_ERROR: 'Unable to show selected lots data.',
  PLACE_BIDS_ERROR: 'Unable to place bids.',
  PLACE_BIDS_ERROR_TRY_AGAIN: 'Cannot place your bids at the moment. Please try again later!',
  CANCEL_BIDS_ERROR_TRY_AGAIN: 'Cannot cancel your bid at the moment. Please try again!'
};
